import { useState } from "react";
import { discussionCount, discussions } from "@/mocks/home";
import Reveal from "./Reveal";

export default function Discussion() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState("");
  const [notice, setNotice] = useState("");

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePublish = () => {
    setNotice(
      draft.trim()
        ? "已记录你的看法（展示态，暂不接真实提交）"
        : "先写点什么再发布吧",
    );
  };

  return (
    <section id="discussion" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="bg-accent-50 border border-accent-200 rounded-lg overflow-hidden">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 px-5 md:px-8 py-6 bg-accent-100/70 border-b border-accent-200">
            <div>
              <span className="text-xs tracking-[0.3em] text-accent-800 uppercase">Talks</span>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                讨论区 · 大家在补哪段
              </h2>
            </div>
            <div className="inline-flex items-center gap-2 h-10 px-4 rounded-full bg-background-50 border border-accent-200 text-sm text-foreground-800 whitespace-nowrap">
              <i className="ri-chat-smile-2-line text-accent-700" />
              已有 {discussionCount} 条讨论
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-5 md:p-8">
            <div className="lg:col-span-7 flex flex-col gap-4">
              {discussions.map((item, index) => (
                <Reveal
                  key={item.id}
                  delay={index * 60}
                  className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden border border-background-200 shrink-0">
                      <img
                        src={item.avatar}
                        alt={item.user}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex-1">
                      <span className="block text-sm font-medium text-foreground-950">
                        {item.user}
                      </span>
                      <span className="block text-[11px] text-foreground-500">{item.time}</span>
                    </div>
                  </div>
                  <p className="mt-3 text-sm leading-7 text-foreground-700">{item.text}</p>
                  <div className="mt-3 flex items-center gap-4">
                    <button
                      type="button"
                      onClick={() => toggleLike(item.id)}
                      className={`inline-flex items-center gap-1.5 text-xs transition-colors whitespace-nowrap cursor-pointer ${
                        liked[item.id] ? "text-primary-600" : "text-foreground-500 hover:text-primary-600"
                      }`}
                    >
                      <i className={liked[item.id] ? "ri-heart-3-fill" : "ri-heart-3-line"} />
                      {item.likes + (liked[item.id] ? 1 : 0)}
                    </button>
                    <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                      <i className="ri-reply-line" />
                      回复
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>

            <div className="lg:col-span-5">
              <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 sticky top-24">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  说说你补课时的发现
                </h3>
                <p className="mt-2 text-xs leading-6 text-foreground-600">
                  哪条线索没接上、哪份合集整理得好，都可以留在这里，方便后来的人少走弯路。
                </p>
                <textarea
                  value={draft}
                  onChange={(event) => setDraft(event.target.value)}
                  maxLength={500}
                  rows={5}
                  placeholder="例如：2025 那条时间线里，第三段和第五段的日期好像对不上……"
                  className="mt-4 w-full rounded-md border border-background-300 bg-background-50 p-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-400 resize-none"
                />
                <div className="mt-2 flex items-center justify-between text-[11px] text-foreground-500">
                  <span>最多 500 字</span>
                  <span>{draft.length}/500</span>
                </div>
                <button
                  type="button"
                  onClick={handlePublish}
                  className="mt-4 w-full h-11 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  发布看法
                </button>
                {notice && <p className="mt-3 text-xs text-accent-800">{notice}</p>}

                <div className="mt-6 pt-5 border-t border-background-200">
                  <span className="text-xs text-foreground-500">热门话题</span>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {["#合约风波", "#回应口径", "#早年整理", "#人物线"].map((topic) => (
                      <button
                        key={topic}
                        type="button"
                        onClick={() => setDraft((prev) => `${prev}${topic} `.trimStart())}
                        className="h-8 px-3 rounded-full bg-secondary-100 text-secondary-800 text-xs hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {topic}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}